
import { Typography } from '@mui/material';
import { ReactElement, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { Actions } from '../Actions';
import { ImportVehicleActions } from '../ImportVehicleActions';
import { Container, Content } from './style';

interface IProps {
  title?: string;
  setIsOpen: (value: boolean) => void;
  fileTypes: string[];
  inputName?: string;
  label?: string;
  confirmButtonText?: string;
  onConfirm: (file: File) => void;
  children?: ReactElement;
  isImportVehicles?: boolean;
  templateUrl?: string;
}

const StyledUploadFileModal = ({ 
  title, 
  setIsOpen, 
  fileTypes, 
  inputName = "file-input",
  label = "Selecione ou arraste o arquivo aqui...",
  confirmButtonText = "Importar",
  onConfirm,
  children = <></>,
  isImportVehicles = false,
  templateUrl,
}: IProps) => {
  const [file, setFile] = useState<File | null>(null);

  const handleChange = (file: File) => {
    setFile(file);
  };
  const backgroundImage = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%23000000FF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`;
  const borderRadius = `18px`;

  return (
    <Container>
      <Content>
        <div className="title">
          {title && <p>{title}</p>}
        </div>

        { children }

        {!file && (
          <FileUploader
            handleChange={handleChange}
            name={inputName}
            types={fileTypes}
            label={label}
            onHover=""
          >
            <div
              className="upload-box"
              style={{ backgroundImage: backgroundImage, borderRadius: borderRadius }}
            >
              <div className="box box-2">
                <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                  {label}
                </Typography>
              </div>
            </div>
          </FileUploader>
        )}

        {file && (
          <p>Arquivo: <span>{file.name} </span></p>
        )}
        
        {isImportVehicles ? 
          (<ImportVehicleActions 
            confirmText={confirmButtonText}
            isConfirmDisabled={!file}
            onCancel={() => setIsOpen(false)}
            onConfirm={() => file && onConfirm(file)}
            templateUrl={templateUrl ?? 'https://www.zignet.com.br/'}
          />) :
          (
            (<Actions 
              confirmText={confirmButtonText}
              isConfirmDisabled={!file}
              onCancel={() => setIsOpen(false)}
              onConfirm={() => file && onConfirm(file)}
            />)
          )
        }
        
      </Content>
    </Container>
  )
}

export { StyledUploadFileModal };
